// extracted by mini-css-extract-plugin
export default {"modal_footer":"ShopifyModal_modal_footer__1xag6","image_shopify":"ShopifyModal_image_shopify__-mcWS","form-label":"ShopifyModal_form-label__l7tI4"};